import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"

function getEnvValue(key: keyof ImportMetaEnv) {
  return import.meta.env[key]?.trim() || ""
}

function getNodeEnv() {
  if (typeof process !== "undefined") {
    return process.env.NODE_ENV
  }

  return undefined
}

function getTracesSampleRate() {
  const value = Number(getEnvValue("REACT_APP_SENTRY_TRACES_SAMPLE_RATE"))

  if (!Number.isFinite(value)) {
    return 0
  }

  return Math.min(Math.max(value, 0), 1)
}

export function initSentry() {
  const dsn = getEnvValue("REACT_APP_SENTRY_DSN") || getEnvValue("REACT_APP_DSN")

  if (!dsn) {
    return
  }

  Sentry.init({
    dsn,
    environment:
      getEnvValue("REACT_APP_SENTRY_ENVIRONMENT") ||
      getEnvValue("REACT_APP_ENV") ||
      getNodeEnv(),
    release: getEnvValue("REACT_APP_SENTRY_RELEASE") || undefined,
    tracesSampleRate: getTracesSampleRate(),
    integrations: [new BrowserTracing()],
  })
}
